import { render, staticRenderFns } from "./IconBase.vue?vue&type=template&id=cb645700&"
import script from "./IconBase.vue?vue&type=script&lang=ts&"
export * from "./IconBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports